export default __webpack_public_path__ + "static/media/lightBulb.e3f73293.svg";